import { getModuleFederatedName, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import { serviceBusBaseClass } from './service-setup/ServiceBus';
import serviceNames, { ApptBookingService } from './service-setup/ApptBookingService';

import './exported/cancellation-confirmation/index';

setupServiceInfo(__serviceInfo__);
const { name, version } = __serviceInfo__;

ApptBookingService.setViews(name, getModuleFederatedName(name), version, [
    'appt-booking-landing',
    'elc-appt-booking-cancellation-confirmation'
]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('./service-setup/diContainer'),
    serviceKey: serviceNames.apptBookingService,
    serviceBusControllerKey: serviceNames.serviceBusController,
    serviceBus: {
        serviceBusBaseClass
    }
});
